<script lang="ts">
  import type { CustomFieldDef, CustomValues } from '$lib/types';

  let { defs, values = $bindable() }: { defs: CustomFieldDef[]; values: CustomValues } = $props();

  function setValue(key: string, v: unknown) {
    values[key] = v;
  }

  function toggleMultiselect(key: string, opt: string) {
    const current = Array.isArray(values[key]) ? [...(values[key] as string[])] : [];
    const idx = current.indexOf(opt);
    if (idx >= 0) current.splice(idx, 1);
    else current.push(opt);
    setValue(key, current);
  }
</script>

{#if defs.length}
  <div class="border-t border-toyama-cloudy-gray pt-4 mt-4">
    <h3 class="mb-4 text-[11px] font-semibold text-toyama-teal uppercase tracking-[.08em]">Custom fields</h3>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    {#each defs as def (def.id)}
      <div>
        <label class="label" for={`cf-${def.id}`}>{def.label}</label>
        {#if def.type === 'text'}
          <input
            id={`cf-${def.id}`}
            type="text"
            class="input"
            value={String(values[def.key] ?? '')}
            oninput={(e) => setValue(def.key, (e.currentTarget as HTMLInputElement).value)}
          />
        {:else if def.type === 'number'}
          <input
            id={`cf-${def.id}`}
            type="number"
            class="input"
            value={values[def.key] != null ? String(values[def.key]) : ''}
            oninput={(e) => {
              const v = (e.currentTarget as HTMLInputElement).value;
              setValue(def.key, v === '' ? null : Number(v));
            }}
          />
        {:else if def.type === 'date'}
          <input
            id={`cf-${def.id}`}
            type="date"
            class="input"
            value={String(values[def.key] ?? '')}
            oninput={(e) => setValue(def.key, (e.currentTarget as HTMLInputElement).value)}
          />
        {:else if def.type === 'checkbox'}
          <input
            id={`cf-${def.id}`}
            type="checkbox"
            checked={Boolean(values[def.key])}
            onchange={(e) => setValue(def.key, (e.currentTarget as HTMLInputElement).checked)}
            class="rounded border-gray-300"
          />
        {:else if def.type === 'select'}
          <select
            id={`cf-${def.id}`}
            class="input"
            value={String(values[def.key] ?? '')}
            onchange={(e) => setValue(def.key, (e.currentTarget as HTMLSelectElement).value)}
          >
            <option value="">--</option>
            {#each def.options as opt (opt)}
              <option value={opt}>{opt}</option>
            {/each}
          </select>
        {:else if def.type === 'multiselect'}
          <div class="flex flex-wrap gap-2">
            {#each def.options as opt (opt)}
              {@const selected = Array.isArray(values[def.key]) && (values[def.key] as string[]).includes(opt)}
              <button
                type="button"
                class="tym-chip !min-h-0 !px-2.5 !py-1 !text-xs {selected ? 'active' : ''}"
                onclick={() => toggleMultiselect(def.key, opt)}
              >
                {opt}
              </button>
            {/each}
          </div>
        {/if}
      </div>
    {/each}
    </div>
  </div>
{/if}
